import {
  buildResultTemplatesManager,
  ResultTemplate,
  Result,
  SearchEngine
} from '@coveo/headless';
import React from 'react';

import { headlessEngine } from '../../engine';
import {
  fieldsToInclude,
  fieldsObject,
  certificationImages,
  labelsObj
} from '../../controllers/controller';
import ContractorCard from './card';
type ProjectListingResultProps = Result & {
  UniqueId: string;
  Uri: string;
  solutionType: string;
  title: string;
  image: string;
  imageAlt: string;
  copy: string;
  index: number;
};

export const resultTemplatesManager = buildResultTemplatesManager(
  headlessEngine as SearchEngine
);

const ProjectListingResultTemplate: ResultTemplate = {
  conditions: [],
  fields: ['UniqueId', 'Uri', ...fieldsToInclude],
  content: (result: ProjectListingResultProps) => (
    <li key={result.UniqueId}>
      <ContractorCard
        index={result.index}
        id={result.UniqueId}
        contractorId={result.raw[fieldsObject.contractorId] as string}
        contractorType={result.raw[fieldsObject.contractorType] as string}
        imgSource={result.raw[fieldsObject.image] as string}
        imgAlt={result.raw[fieldsObject.imageAlt] as string}
        contractorDBA={result.raw[fieldsObject.contractorDBA] as string}
        contractorName={result.raw[fieldsObject.contractorName] as string}
        contractorRating={result.raw[fieldsObject.rating] as number}
        contractorReviews={result.raw[fieldsObject.range] as number}
        city={result.raw[fieldsObject.city] as string}
        stateAbbreviation={result.raw[fieldsObject.state] as string}
        distance={result.raw[fieldsObject.distanceInMiles] as string}
        certificationsLabel={labelsObj.certificationsCardLabel}
        certifications={(result.raw[fieldsObject.contractorType] as string)?.toLowerCase() === 'residential'
          ? (result.raw[fieldsObject.contractorCertificationsResidential] as string[])
          : (result.raw[fieldsObject.contractorCertificationsCommercial] as string[])}
        contractorDesignations={
          (result.raw[fieldsObject.contractorType] as string)?.toLowerCase() === 'residential'
            ? (result.raw[fieldsObject.contractorDesignationsResidential] as string[])
            : (result.raw[fieldsObject.contractorDesignationsCommercial] as string[])
        }
        moreCertificationsLabel={labelsObj.moreCertificationsLabel}
        viewAllCertificationsLabel={labelsObj.viewAllCertificationsLabel}
        certificationImages={certificationImages}
        quoteLabel={labelsObj.requestAQuoteLabel}
        phone={result.raw[fieldsObject.phone] as string}
        link={result.raw[fieldsObject.link] as string}
        countryCode={result.raw[fieldsObject.countryCode] as string}
        isLead={result.raw[fieldsObject.isLead] as number}
        result={result}
      />
    </li>
  )
};

resultTemplatesManager.registerTemplates(ProjectListingResultTemplate);
